import { Box, Skeleton, useMediaQuery, useTheme } from '@mui/material';
import React, { useState, useEffect } from 'react';
import StatCard from './components/StatCard';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import { useDispatch } from 'react-redux';
import { getStudentPerfomanceDashboard } from '../../../../redux/features/CRDslice';
import { useSelector } from 'react-redux';
import GlobalDatagrid from '../../../../components/mui/DataGrid/GlobalDatagrid';
import { columns } from './components/getColumns';
import Filter from './components/Filters';
import { StudentDashboardCardJson } from './utils/studentDashboardCards';

export default function StudentDashboard() {
  const cards = useSelector((state) => state.crd.studentPerfomanceDasboard?.data?.cards);
  const result = useSelector((state) => state.crd.studentPerfomanceDasboard?.data?.result);
  const meta = useSelector((state) => state.crd.studentPerfomanceDasboard?.meta);
  const loading = useSelector((state) => state.crd.studentPerfomanceDasboard?.loading);

  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, search } = paginationData;

  //Filters
  const [allFilter, setAllFilter] = useState({
    subject_id: '',
    course_id: '',
    cro_id: '',
    percentage: { id: 0, label: null },
    examType: { id: 0, value: null },
  });

  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const dispatch = useDispatch();

  useEffect(() => {}, []);

  useEffect(() => {
    dispatch(
      getStudentPerfomanceDashboard({
        page: pageNum,
        limit: gridSize,
        subject_id: allFilter.subject_id,
        course_id: allFilter.course_id,
        cro_id: allFilter.cro_id,
        search,
        performance: allFilter?.percentage?.id || null,
        type: allFilter?.examType?.id || null,
      }),
    );
  }, [dispatch, gridSize, pageNum, search, allFilter]);

  return (
    <GlobalWrapper title="Student Performance Dashboard">
      <Box sx={{ flex: 1, p: { xs: 1.5, sm: 2, md: 3 } }}>
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            mb: 3,
            flexWrap: 'wrap',
            justifyContent: isSmall ? 'center' : 'flex-start',
          }}
        >
          {loading
            ? Array.from({ length: StudentDashboardCardJson.length }).map((e, i) => (
                <Skeleton height={150} width={160} key={i} />
              ))
            : StudentDashboardCardJson.map(({ title, value, noPercentage }) => (
                <StatCard title={title} value={`${cards?.[value]}${!noPercentage ? '%' : ''}`} />
              ))}
        </Box>

        {/* --- Filters --- */}
        <Box
          sx={{
            mb: 3,
            display: 'flex',
            flexDirection: isSmall ? 'column' : 'row',
            alignItems: isSmall ? 'stretch' : 'center',
            gap: 2,
          }}
        >
          <Filter setAllFilter={setAllFilter} percentageFilter allFilter={allFilter} />
        </Box>

        <GlobalDatagrid
          tableHead={columns}
          rows={result ?? []}
          meta={meta?.totalRecords}
          rowUniqueId={'sl_no'}
          loading={loading}
        />
      </Box>
    </GlobalWrapper>
  );
}
